import React from 'react';         // Import React for JSX syntax
import ReactDOM from 'react-dom';   // Import ReactDOM for rendering
import App from './App';            // Import App component


ReactDOM.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
    document.getElementById('root')
  );
  